import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";
import * as API from "../../Endpoints/Endpoints";

const socket = io(API.SOCKET_URL, {
    transports: ["websocket", "polling"],
});

const MultiplayerGame = () => {
    const [opponent, setOpponent] = useState(null);
    const [gameState, setGameState] = useState(Array(9).fill(null)); // Example: Tic-Tac-Toe board
    const [currentTurn, setCurrentTurn] = useState("X"); // Example turn system
    const [playerSymbol, setPlayerSymbol] = useState(null);

    const navigate = useNavigate();
    const currentUser = localStorage.getItem("email");

    useEffect(() => {
        // Listen for opponent assignment
        socket.on("gameStarted", ({ opponent, symbol }) => {
            setOpponent(opponent);
            setPlayerSymbol(symbol);
        });

        // Listen for game updates
        socket.on("updateGame", ({ player, moveIndex, symbol }) => {
            setGameState(prevState => {
                const newState = [...prevState];
                newState[moveIndex] = symbol;
                return newState;
            });
            setCurrentTurn(symbol === "X" ? "O" : "X"); // Swap turns
        });

        // Listen for game end
        socket.on("gameEnded", ({ message }) => {
            alert(message);
            navigate("/playdbtable"); // Redirect after game ends
        });

        return () => {
            socket.off("gameStarted");
            socket.off("updateGame");
            socket.off("gameEnded");
        };
    }, [navigate]);

    // Send move to server
    const makeMove = (index) => {
        if (gameState[index] || currentTurn !== playerSymbol) return; // Prevent invalid moves
        socket.emit("gameMove", { player: currentUser, moveIndex: index, symbol: playerSymbol });
    };

    return (
        <div className="p-6 text-center">
            <h2 className="text-2xl font-bold">Multiplayer Game</h2>
            <p>Opponent: {opponent ? opponent : "Waiting for opponent..."}</p>
            <p>Your Symbol: {playerSymbol}</p>
            <p>Current Turn: {currentTurn}</p>

            {/* Example Tic-Tac-Toe Board */}
            <div className="grid grid-cols-3 gap-2 mt-4 w-40 mx-auto">
                {gameState.map((cell, index) => (
                    <div 
                        key={index} 
                        className="p-4 border text-xl font-bold flex items-center justify-center cursor-pointer"
                        onClick={() => makeMove(index)}
                        style={{ height: "50px", width: "50px", background: cell ? "#ddd" : "white" }}
                    >
                        {cell}
                    </div>
                ))}
            </div>

            <button 
                className="mt-4 bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => socket.emit("endGame", { player: currentUser })}
            >
                End Game
            </button>
        </div>
    );
};

export default MultiplayerGame;
